// 2020-06-27export { MyGroupUpDownValueComponent } from './my-group-up-down-value.component';